import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { EMPTY_PIXEL } from '~/const/images';
import { formatPrismicImage } from '~/helpers/image-helper';

var GlobalRichText = function GlobalRichText() {
  return import(
  /* webpackChunkName:"global-editorial" */
  '~/components/atoms/Editorial/Global/GlobalRichText.vue');
};

var Cta = function Cta() {
  return import('~/components/atoms/Cta.vue');
};

export default {
  name: 'ChristmasDestockingBanner',
  components: {
    GlobalRichText: GlobalRichText,
    Cta: Cta
  },
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  computed: {
    currentPayload: function currentPayload() {
      var _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13;

      return {
        background_color: ((_ref13 = this.payload) != null ? (_ref13 = _ref13.primary) != null ? _ref13.background_color : _ref13 : _ref13) || '',
        background_image: formatPrismicImage((_ref12 = this.payload) != null ? (_ref12 = _ref12.primary) != null ? (_ref12 = _ref12.background_image) != null ? _ref12.url : _ref12 : _ref12 : _ref12) || EMPTY_PIXEL,
        color: ((_ref11 = this.payload) != null ? (_ref11 = _ref11.primary) != null ? _ref11.text_color : _ref11 : _ref11) || '',
        title: ((_ref10 = this.payload) != null ? (_ref10 = _ref10.primary) != null ? _ref10.title : _ref10 : _ref10) || [],
        subtitle: ((_ref9 = this.payload) != null ? (_ref9 = _ref9.primary) != null ? _ref9.subtitle : _ref9 : _ref9) || [],
        image: {
          alt: ((_ref8 = this.payload) != null ? (_ref8 = _ref8.primary) != null ? (_ref8 = _ref8.icon) != null ? _ref8.alt : _ref8 : _ref8 : _ref8) || '',
          small: formatPrismicImage((_ref7 = this.payload) != null ? (_ref7 = _ref7.primary) != null ? (_ref7 = _ref7.icon) != null ? _ref7.url : _ref7 : _ref7 : _ref7) || EMPTY_PIXEL
        },
        button: {
          color: ((_ref6 = this.payload) != null ? (_ref6 = _ref6.primary) != null ? _ref6.cta_text_color : _ref6 : _ref6) || '',
          text: ((_ref5 = this.payload) != null ? (_ref5 = _ref5.primary) != null ? _ref5.cta : _ref5 : _ref5) || '',
          url: ((_ref4 = this.payload) != null ? (_ref4 = _ref4.primary) != null ? (_ref4 = _ref4.url) != null ? _ref4.url : _ref4 : _ref4 : _ref4) || '',
          tracking: {
            data: {
              event_category: ((_ref3 = this.payload) != null ? (_ref3 = _ref3.primary) != null ? _ref3.event_category : _ref3 : _ref3) || '',
              event_action: ((_ref2 = this.payload) != null ? (_ref2 = _ref2.primary) != null ? _ref2.event_action : _ref2 : _ref2) || '',
              event_label: ((_ref = this.payload) != null ? (_ref = _ref.primary) != null ? _ref.event_label : _ref : _ref) || ''
            }
          }
        }
      };
    }
  }
};